// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IClaimAppealDocumentUploadResponseDto
 */
export interface IClaimAppealDocumentUploadResponseDto {
    /**
     * 
     * @type {string}
     * @memberof IClaimAppealDocumentUploadResponseDto
     */
    document_file_path?: string;
    /**
     * 
     * @type {string}
     * @memberof IClaimAppealDocumentUploadResponseDto
     */
    document_fetch_url?: string;
}

/**
 * Check if a given object implements the IClaimAppealDocumentUploadResponseDto interface.
 */
export function instanceOfIClaimAppealDocumentUploadResponseDto(value: object): value is IClaimAppealDocumentUploadResponseDto {
    return true;
}

export function IClaimAppealDocumentUploadResponseDtoFromJSON(json: any): IClaimAppealDocumentUploadResponseDto {
    return IClaimAppealDocumentUploadResponseDtoFromJSONTyped(json, false);
}

export function IClaimAppealDocumentUploadResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IClaimAppealDocumentUploadResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'document_file_path': json['document_file_path'] == null ? undefined : json['document_file_path'],
        'document_fetch_url': json['document_fetch_url'] == null ? undefined : json['document_fetch_url'],
    };
}

export function IClaimAppealDocumentUploadResponseDtoToJSON(json: any): IClaimAppealDocumentUploadResponseDto {
    return IClaimAppealDocumentUploadResponseDtoToJSONTyped(json, false);
}

export function IClaimAppealDocumentUploadResponseDtoToJSONTyped(value?: IClaimAppealDocumentUploadResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'document_file_path': value['document_file_path'],
        'document_fetch_url': value['document_fetch_url'],
    };
}

